import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { Subscription } from 'rxjs';
import { saveAs } from 'file-saver';
import { LoaderService } from '../../../../services/infrastructure/loader.service';
import { EdlpService } from './../../../../services/cpp/edlp.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-everyday-low-price-list',
  templateUrl: './everyday-low-price-list.component.html',
  styleUrls: ['./everyday-low-price-list.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class EverydayLowPriceListComponent implements OnInit, OnDestroy {
  subscription = new Array<Subscription>();
  EDLPDataSource: MatTableDataSource<any>;
  EDLPPricingList: any = [];
  FilteredData: any = [];
  lastRefreshDate: any;
  termsConditions: string = '';
  isPricingReady: boolean = false;
  isLoading: boolean = true;
  noDataMessage: string = '';
  isSubscribed: boolean = false;
  isSubscriptionBusy: boolean = false;
  isSubsModalShow: boolean = false;
  isSubClick: boolean = false;

  // Sold-To
  eligibleAccounts: any[] = [];
  selectedAccount: number = null;

  // Filters — option lists and selected values
  productBrandData: any[] = [];
  activeIngredientData: any[] = [];
  itemNumberData: any[] = [];
  itemDescriptionData: any[] = [];
  packSizeData: any[] = [];
  searchProductBrand: any[] = [];
  searchActiveIngredient: any[] = [];
  searchItemNumber: any[] = [];
  searchItemDescription: any[] = [];
  searchPackSize: any[] = [];
  brandSearchText = '';
  activeIngredientSearchText = '';
  itemNumberSearchText = '';
  itemDescriptionSearchText = '';
  packSizeSearchText = '';
  // Stable filtered lists — only updated on search text change, not on every CD cycle
  filteredProductBrands: any[] = [];
  filteredActiveIngredients: any[] = [];
  filteredItemNumbers: any[] = [];
  filteredItemDescriptions: any[] = [];
  filteredPackSizes: any[] = [];

  // Grouped data
  groupedData: { brand: string; items: any[] }[] = [];

  displayedColumns: string[] = [
    'itemNumber', 'itemDescription', 'activeIngredients', 'productBrand',
    'packSize', 'uom', 'basePriceWithFreight',
    'midVolumePrice', 'maxVolumePrice',
    'midVolumeQty', 'maxVolumeQty',
    'paymentTermsDescription'
  ];

  constructor(
    private edlpService: EdlpService,
    private loaderService: LoaderService,
    private toastrService: ToastrService
  ) { }

  get isStatus(): string {
    return this.isSubscribed ? 'Subscribed' : 'Unsubscribed';
  }

  get selectedAccountName(): string {
    const account = this.eligibleAccounts?.find(x => x.accountNumber === this.selectedAccount);
    return account?.accountName || '';
  }

  ngOnInit(): void {
    this.loadInitialData();
  }

  ngOnDestroy(): void {
    this.subscription.forEach(s => s.unsubscribe());
  }

   loadInitialData() {
    this.loaderService.setLoaderStatus(true);
 
    this.subscription.push(this.edlpService.getEDLPInitialData().subscribe((data: any) => {
      const config = data?.config;
      if (config) {
        this.termsConditions = config.termsConditions || '';
 
        if (config.endOfDayFileValue !== 0) {
          this.isPricingReady = false;
          this.noDataMessage = 'No WinField United Prop HIF Price Sheet is available for the selected account and filters. Please adjust your filters or try again later';
          this.isLoading = false;
          this.loaderService.setLoaderStatus(false);
          return;
        }
        this.isPricingReady = true;
      }
 
      this.eligibleAccounts = data?.eligibleAccounts || [];
      this.lastRefreshDate = data?.lastRefreshDate;
      this.isLoading = false;
      this.loaderService.setLoaderStatus(false);
 
      // Auto-select when user has exactly one Sold-To account.
      if (this.eligibleAccounts.length === 1) {
        this.selectedAccount = this.eligibleAccounts[0].accountNumber;
        this.onAccountChange();
      }
    }, error => {
      this.isLoading = false;
      this.loaderService.setLoaderStatus(false);
    }));
  }

  onAccountChange() {
    if (!this.selectedAccount) {
      this.EDLPPricingList = [];
      this.FilteredData = [];
      this.EDLPDataSource = null;
      this.groupedData = [];
      this.productBrandData = [];
      this.activeIngredientData = [];
      this.itemNumberData = [];
      this.itemDescriptionData = [];
      this.packSizeData = [];
      this.searchProductBrand = [];
      this.searchActiveIngredient = [];
      this.searchItemNumber = [];
      this.searchItemDescription = [];
      this.searchPackSize = [];
      this.isSubscribed = false;
      this.isSubsModalShow = false;
      return;
    }
    // Changing Sold-To account clears all five filters — no carry-over of prior selections.
    this.searchProductBrand = [];
    this.searchActiveIngredient = [];
    this.searchItemNumber = [];
    this.searchItemDescription = [];
    this.searchPackSize = [];
    this.isSubsModalShow = false;
    this.loadPricingData();
    this.loadSubscriptionStatus();
  }

  loadSubscriptionStatus() {
    if (!this.selectedAccount) {
      this.isSubscribed = false;
      return;
    }

    this.subscription.push(this.edlpService.getEDLPSubscriptionStatus(this.selectedAccount).subscribe((result: any) => {
      this.isSubscribed = result;
    }, error => {
      this.isSubscribed = false;
    }));
  }

  showHideSubscription(): void {
    if (!this.selectedAccount || this.isSubscriptionBusy || !this.isPricingReady) {
      return;
    }

    this.isSubClick = true;
    this.isSubsModalShow = !this.isSubsModalShow;
  }

  closePopup(): void {
    if (!this.isSubClick) {
      this.isSubsModalShow = false;
    }
    this.isSubClick = false;
  }

  changeStatus(update: boolean = false): void {
    if (!this.selectedAccount || this.isSubscriptionBusy) {
      return;
    }

    const nextStatus = update ? true : !this.isSubscribed;

    this.isSubscriptionBusy = true;
    this.loaderService.setLoaderStatus(true);
    this.subscription.push(this.edlpService.updateEDLPSubscription(this.selectedAccount).subscribe((isUpdated: any) => {
      this.loaderService.setLoaderStatus(false);
      this.isSubscriptionBusy = false;
      if (isUpdated) {
        this.isSubscribed = nextStatus;
        this.isSubsModalShow = false;
        //if (update && this.isSubscribed) {
        //  this.toastrService.success('Subscription updated successfully.');
        //} else {
        //  this.toastrService.success(nextStatus ? 'Subscribed successfully.' : 'Unsubscribed successfully.');
        }
      //} else {
      //  this.toastrService.error('Unable to update subscription. Please try again or contact support.');
      //}
    }, error => {
      this.loaderService.setLoaderStatus(false);
      this.isSubscriptionBusy = false;
      this.toastrService.error('Unable to update subscription. Please try again or contact support.');
    }));
  }

  loadPricingData() {
    this.loaderService.setLoaderStatus(true);
    this.subscription.push(this.edlpService.getEDLPPricingData(this.selectedAccount).subscribe((result: any[]) => {
      this.EDLPPricingList = result || [];
      this.FilteredData = this.EDLPPricingList;

      // Build distinct filter lists as objects for ng-select groupBy/bindValue/bindLabel
      const brandSet = new Set<string>();
      this.EDLPPricingList.forEach(x => {
        const val = (x.productBrand != null && String(x.productBrand).trim() !== '')
          ? String(x.productBrand).trim()
          : 'BLANK';
        brandSet.add(val);
      });
      this.productBrandData = Array.from(brandSet)
        .sort((a, b) => a.localeCompare(b))
        .map(b => ({ productBrand: b, selectedAllGroupProductBrand: 'selectedAllGroupProductBrand' }));

      const aiSet = new Set<string>();
      this.EDLPPricingList.forEach(x => {
        const val = (x.activeIngredients != null && String(x.activeIngredients).trim() !== '')
          ? String(x.activeIngredients).trim()
          : 'BLANK';
        aiSet.add(val);
      });
      this.activeIngredientData = Array.from(aiSet)
        .sort((a, b) => a.localeCompare(b))
        .map(ai => ({ activeIngredients: ai, selectedAllGroupActiveIngredient: 'selectedAllGroupActiveIngredient' }));

      const itemNumberSet = new Set<string>();
      this.EDLPPricingList.forEach(x => {
        const val = (x.itemNumber != null && String(x.itemNumber).trim() !== '')
          ? String(x.itemNumber).trim()
          : 'BLANK';
        itemNumberSet.add(val);
      });
      this.itemNumberData = Array.from(itemNumberSet)
        .sort((a, b) => a.localeCompare(b))
        .map(v => ({ itemNumber: v }));

      const itemDescriptionSet = new Set<string>();
      this.EDLPPricingList.forEach(x => {
        const val = (x.itemDescription != null && String(x.itemDescription).trim() !== '')
          ? String(x.itemDescription).trim()
          : 'BLANK';
        itemDescriptionSet.add(val);
      });
      this.itemDescriptionData = Array.from(itemDescriptionSet)
        .sort((a, b) => a.localeCompare(b))
        .map(v => ({ itemDescription: v }));

      const packSizeSet = new Set<string>();
      this.EDLPPricingList.forEach(x => {
        const val = (x.packSize != null && String(x.packSize).trim() !== '')
          ? String(x.packSize).trim()
          : 'BLANK';
        packSizeSet.add(val);
      });
      this.packSizeData = Array.from(packSizeSet)
        .sort((a, b) => a.localeCompare(b))
        .map(v => ({ packSize: v }));

      this.searchProductBrand = [];
      this.searchActiveIngredient = [];
      this.searchItemNumber = [];
      this.searchItemDescription = [];
      this.searchPackSize = [];

      // Initialise stable filtered lists
      this.updateFilteredProductBrands();
      this.updateFilteredActiveIngredients();
      this.updateFilteredItemNumbers();
      this.updateFilteredItemDescriptions();
      this.updateFilteredPackSizes();

      this.applyFiltersAndGroup();
      this.loaderService.setLoaderStatus(false);
    }, error => {
      this.loaderService.setLoaderStatus(false);
    }));
  }

  filterRecords() {
    let data = this.EDLPPricingList;

    if (this.searchProductBrand && this.searchProductBrand.length > 0) {
      data = data.filter(x => {
        const val = (x.productBrand != null && String(x.productBrand).trim() !== '')
          ? String(x.productBrand).trim()
          : 'BLANK';
        return this.searchProductBrand.indexOf(val) > -1;
      });
    }

    if (this.searchActiveIngredient && this.searchActiveIngredient.length > 0) {
      data = data.filter(x => {
        const val = (x.activeIngredients != null && String(x.activeIngredients).trim() !== '')
          ? String(x.activeIngredients).trim()
          : 'BLANK';
        return this.searchActiveIngredient.indexOf(val) > -1;
      });
    }

    if (this.searchItemNumber && this.searchItemNumber.length > 0) {
      data = data.filter(x => {
        const val = (x.itemNumber != null && String(x.itemNumber).trim() !== '')
          ? String(x.itemNumber).trim()
          : 'BLANK';
        return this.searchItemNumber.indexOf(val) > -1;
      });
    }

    if (this.searchItemDescription && this.searchItemDescription.length > 0) {
      data = data.filter(x => {
        const val = (x.itemDescription != null && String(x.itemDescription).trim() !== '')
          ? String(x.itemDescription).trim()
          : 'BLANK';
        return this.searchItemDescription.indexOf(val) > -1;
      });
    }

    if (this.searchPackSize && this.searchPackSize.length > 0) {
      data = data.filter(x => {
        const val = (x.packSize != null && String(x.packSize).trim() !== '')
          ? String(x.packSize).trim()
          : 'BLANK';
        return this.searchPackSize.indexOf(val) > -1;
      });
    }

    this.FilteredData = data;
    this.applyFiltersAndGroup();
  }

  updateFilteredProductBrands(): void {
    const q = (this.brandSearchText || '').trim().toLowerCase();
    this.filteredProductBrands = !q
      ? this.productBrandData
      : this.productBrandData.filter(b => b.productBrand && b.productBrand.toLowerCase().indexOf(q) > -1);
  }

  updateFilteredActiveIngredients(): void {
    const q = (this.activeIngredientSearchText || '').trim().toLowerCase();
    this.filteredActiveIngredients = !q
      ? this.activeIngredientData
      : this.activeIngredientData.filter(b => b.activeIngredients && b.activeIngredients.toLowerCase().indexOf(q) > -1);
  }

  updateFilteredItemNumbers(): void {
    const q = (this.itemNumberSearchText || '').trim().toLowerCase();
    this.filteredItemNumbers = !q
      ? this.itemNumberData
      : this.itemNumberData.filter(b => b.itemNumber && String(b.itemNumber).toLowerCase().indexOf(q) > -1);
  }

  updateFilteredItemDescriptions(): void {
    const q = (this.itemDescriptionSearchText || '').trim().toLowerCase();
    this.filteredItemDescriptions = !q
      ? this.itemDescriptionData
      : this.itemDescriptionData.filter(b => b.itemDescription && String(b.itemDescription).toLowerCase().indexOf(q) > -1);
  }

  updateFilteredPackSizes(): void {
    const q = (this.packSizeSearchText || '').trim().toLowerCase();
    this.filteredPackSizes = !q
      ? this.packSizeData
      : this.packSizeData.filter(b => b.packSize && String(b.packSize).toLowerCase().indexOf(q) > -1);
  }

  allBrandsSelected(): boolean {
    return this.productBrandData.length > 0 &&
      this.searchProductBrand.length === this.productBrandData.length;
  }

  allActiveIngredientsSelected(): boolean {
    return this.activeIngredientData.length > 0 &&
      this.searchActiveIngredient.length === this.activeIngredientData.length;
  }

  allItemNumbersSelected(): boolean {
    return this.itemNumberData.length > 0 &&
      this.searchItemNumber.length === this.itemNumberData.length;
  }

  allItemDescriptionsSelected(): boolean {
    return this.itemDescriptionData.length > 0 &&
      this.searchItemDescription.length === this.itemDescriptionData.length;
  }

  allPackSizesSelected(): boolean {
    return this.packSizeData.length > 0 &&
      this.searchPackSize.length === this.packSizeData.length;
  }

  onBrandSelectionChange(): void {
    this.filterRecords();
  }

  onActiveIngredientSelectionChange(): void {
    this.filterRecords();
  }

  onItemNumberSelectionChange(): void {
    this.filterRecords();
  }

  onItemDescriptionSelectionChange(): void {
    this.filterRecords();
  }

  onPackSizeSelectionChange(): void {
    this.filterRecords();
  }

  toggleSelectAllBrands(): void {
    if (this.allBrandsSelected()) {
      this.searchProductBrand = [];
    } else {
      this.selectAllBrands();
    }
    this.filterRecords();
  }

  toggleSelectAllActiveIngredients(): void {
    if (this.allActiveIngredientsSelected()) {
      this.searchActiveIngredient = [];
    } else {
      this.selectAllActiveIngredients();
    }
    this.filterRecords();
  }

  toggleSelectAllItemNumbers(): void {
    if (this.allItemNumbersSelected()) {
      this.searchItemNumber = [];
    } else {
      this.selectAllItemNumbers();
    }
    this.filterRecords();
  }

  toggleSelectAllItemDescriptions(): void {
    if (this.allItemDescriptionsSelected()) {
      this.searchItemDescription = [];
    } else {
      this.selectAllItemDescriptions();
    }
    this.filterRecords();
  }

  toggleSelectAllPackSizes(): void {
    if (this.allPackSizesSelected()) {
      this.searchPackSize = [];
    } else {
      this.selectAllPackSizes();
    }
    this.filterRecords();
  }

  private selectAllBrands(): void {
    this.searchProductBrand = this.productBrandData.map(b => b.productBrand);
  }

  private selectAllActiveIngredients(): void {
    this.searchActiveIngredient = this.activeIngredientData.map(ai => ai.activeIngredients);
  }

  private selectAllItemNumbers(): void {
    this.searchItemNumber = this.itemNumberData.map(v => v.itemNumber);
  }

  private selectAllItemDescriptions(): void {
    this.searchItemDescription = this.itemDescriptionData.map(v => v.itemDescription);
  }

  private selectAllPackSizes(): void {
    this.searchPackSize = this.packSizeData.map(v => v.packSize);
  }

  clearAllBrands(): void {
    this.searchProductBrand = [];
    this.filterRecords();
  }

  clearAllActiveIngredients(): void {
    this.searchActiveIngredient = [];
    this.filterRecords();
  }

  clearAllItemNumbers(): void {
    this.searchItemNumber = [];
    this.filterRecords();
  }

  clearAllItemDescriptions(): void {
    this.searchItemDescription = [];
    this.filterRecords();
  }

  clearAllPackSizes(): void {
    this.searchPackSize = [];
    this.filterRecords();
  }

  clearBrandSearch(ev?: MouseEvent): void {
    ev?.stopPropagation();
    this.brandSearchText = '';
    this.updateFilteredProductBrands();
  }

  clearActiveIngredientSearch(ev?: MouseEvent): void {
    ev?.stopPropagation();
    this.activeIngredientSearchText = '';
    this.updateFilteredActiveIngredients();
  }

  clearItemNumberSearch(ev?: MouseEvent): void {
    ev?.stopPropagation();
    this.itemNumberSearchText = '';
    this.updateFilteredItemNumbers();
  }

  clearItemDescriptionSearch(ev?: MouseEvent): void {
    ev?.stopPropagation();
    this.itemDescriptionSearchText = '';
    this.updateFilteredItemDescriptions();
  }

  clearPackSizeSearch(ev?: MouseEvent): void {
    ev?.stopPropagation();
    this.packSizeSearchText = '';
    this.updateFilteredPackSizes();
  }

  onBrandPanelOpen(): void {
    this.brandSearchText = '';
    this.updateFilteredProductBrands();
  }

  onBrandPanelClose(): void {
    this.brandSearchText = '';
    this.updateFilteredProductBrands();
  }

  onActiveIngredientPanelOpen(): void {
    this.activeIngredientSearchText = '';
    this.updateFilteredActiveIngredients();
  }

  onActiveIngredientPanelClose(): void {
    this.activeIngredientSearchText = '';
    this.updateFilteredActiveIngredients();
  }

  onItemNumberPanelOpen(): void {
    this.itemNumberSearchText = '';
    this.updateFilteredItemNumbers();
  }

  onItemNumberPanelClose(): void {
    this.itemNumberSearchText = '';
    this.updateFilteredItemNumbers();
  }

  onItemDescriptionPanelOpen(): void {
    this.itemDescriptionSearchText = '';
    this.updateFilteredItemDescriptions();
  }

  onItemDescriptionPanelClose(): void {
    this.itemDescriptionSearchText = '';
    this.updateFilteredItemDescriptions();
  }

  onPackSizePanelOpen(): void {
    this.packSizeSearchText = '';
    this.updateFilteredPackSizes();
  }

  onPackSizePanelClose(): void {
    this.packSizeSearchText = '';
    this.updateFilteredPackSizes();
  }

  applyFiltersAndGroup() {
    // Assign a brand group index to each row for alternating band colors
    const brandMap = new Map<string, number>();
    let brandIndex = 0;
    this.FilteredData.forEach(item => {
      const brand = item.productBrand || 'Other';
      if (!brandMap.has(brand)) {
        brandMap.set(brand, brandIndex++);
      }
      item._brandIndex = brandMap.get(brand);
      this.setPriceHighlightClass(item);
    });

    this.EDLPDataSource = new MatTableDataSource(this.FilteredData);

    this.groupedData = Array.from(brandMap.keys()).map(brand => ({ brand, items: [] }));

    if (this.FilteredData.length === 0) {
      this.noDataMessage = 'No WinField United Prop HIF Price Sheet is available for the selected account and filters. Please adjust your filters or try again later';
    } else {
      this.noDataMessage = '';
    }
  }

  setPriceHighlightClass(item: any) {
    const basePrice = this.roundPrice(item.basePriceWithFreight);
    const midPrice = this.roundPrice(item.midVolumePrice);
    const maxPrice = this.roundPrice(item.maxVolumePrice);
    const prices = [basePrice, midPrice, maxPrice].filter(p => p !== null);
    const lowest = prices.length > 1 ? Math.min(...prices) : null;
    const highest = prices.length > 1 ? Math.max(...prices) : null;

    item._basePriceClass = this.getPriceClass(basePrice, lowest, highest);
    item._midPriceClass = this.getPriceClass(midPrice, lowest, highest);
    item._maxPriceClass = this.getPriceClass(maxPrice, lowest, highest);
  }

  getPriceClass(price: number, lowest: number, highest: number) {
    if (price === null || lowest === null || lowest === highest) {
      return '';
    }
    if (price === lowest) {
      return 'edlp-price-lowest';
    }
    if (price === highest) {
      return 'edlp-price-highest';
    }
    return '';
  }

  roundPrice(price: any) {
    if (price === null || price === undefined || price === '' || isNaN(Number(price))) {
      return null;
    }
    return Math.round(Number(price) * 100) / 100;
  }

  onExportBtnClick() {
    this.loaderService.setLoaderStatus(true);
    if (this.FilteredData && this.FilteredData.length > 0) {
      const filter = {
        accountNumber: this.selectedAccount,
        productBrands: this.searchProductBrand && this.searchProductBrand.length > 0 ? this.searchProductBrand : null,
        activeIngredients: this.searchActiveIngredient && this.searchActiveIngredient.length > 0 ? this.searchActiveIngredient : null,
        itemNumbers: this.searchItemNumber && this.searchItemNumber.length > 0 ? this.searchItemNumber : null,
        itemDescriptions: this.searchItemDescription && this.searchItemDescription.length > 0 ? this.searchItemDescription : null,
        packSizes: this.searchPackSize && this.searchPackSize.length > 0 ? this.searchPackSize : null
      };
      this.subscription.push(this.edlpService.exportEDLPExcel(filter).subscribe((result: any) => {
        this.base64toFile(result.base64, result.mimeType, result.fileName);
        this.loaderService.setLoaderStatus(false);
      }, error => {
        this.loaderService.setLoaderStatus(false);
        this.toastrService.error('Export failed. Please try again or contact support.');
      }));
    }
  }

  base64toFile(base64String: string, contentType: string, fileName: string) {
    const blob = this.b64toBlob(base64String, contentType, 550);
    saveAs(blob, fileName);
  }

  b64toBlob(b64Data: string, contentType: string, sliceSize: number) {
    contentType = contentType || '';
    sliceSize = sliceSize || 512;
    b64Data = b64Data.replace(/\s/g, '');
    const byteCharacters = atob(b64Data);
    const byteArrays = [];
    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);
      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      byteArrays.push(new Uint8Array(byteNumbers));
    }
    return new Blob(byteArrays, { type: contentType });
  }

  ddlOptionsSearchProductBrand = (term: string, item: any) => {
    term = term.toLocaleLowerCase();
    return item['productBrand'] && item['productBrand'].toLocaleLowerCase().indexOf(term) > -1;
  };

  ddlOptionsSearchActiveIngredient = (term: string, item: any) => {
    term = term.toLocaleLowerCase();
    return item['activeIngredients'] && item['activeIngredients'].toLocaleLowerCase().indexOf(term) > -1;
  };

  ddlOptionsSearchProductBrandNgSelect = (term: string, item: string) => {
    return item.toLocaleLowerCase().indexOf(term.toLocaleLowerCase()) > -1;
  };

  ddlOptionsSearchActiveIngredientNgSelect = (term: string, item: string) => {
    return item.toLocaleLowerCase().indexOf(term.toLocaleLowerCase()) > -1;
  };

  handleKeyevent = (e: KeyboardEvent) => {
    if (e.key === 'Enter') { e.stopPropagation(); }
    return true;
  };

  handleAccountSearch = (term: string, item: any) => {
    term = term.toLocaleLowerCase();
    const name = item['accountName'] ? item['accountName'].toLocaleLowerCase() : '';
    const number = item['accountNumber'] ? item['accountNumber'].toString() : '';
    return name.indexOf(term) > -1 || number.indexOf(term) > -1;
  };
}
